import NewsletterSignup from "@/components/NewsletterSignup";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-black mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <div className="font-heading text-3xl tracking-widest">FORGED</div>
          <div className="font-sub text-[10px] tracking-[0.4em] text-white/40 mt-1">ATHLETICS</div>
          <p className="font-mono text-xs text-white/40 mt-6 max-w-sm leading-relaxed">
            規律 · 集中 · 力 <br />
            Discipline. Focus. Strength. Built in shadows, forged in iron.
          </p>
        </div>
        <div className="md:col-span-2">
          <div className="font-heading uppercase text-xs tracking-[0.25em] text-white/70 mb-4">Site</div>
          <ul className="space-y-2 font-mono text-xs text-white/50">
            <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
            <li><Link to="/questionnaire" className="hover:text-white">AI Plan</Link></li>
            <li><Link to="/coming-soon" className="hover:text-white">Waifu Collection</Link></li>
            <li><Link to="/legal" className="hover:text-white" data-testid="footer-legal-link">Disclaimer</Link></li>
          </ul>
        </div>
        <div className="md:col-span-5">
          <NewsletterSignup />
        </div>
      </div>

      {/* Always-on micro-disclaimer band */}
      <div className="border-t border-white/5 py-5 px-6 text-center max-w-5xl mx-auto" data-testid="footer-disclaimer">
        <p className="font-mono text-[10px] tracking-wider text-white/40 leading-relaxed">
          All content is for educational and informational purposes only and is NOT medical advice. You use this site at your own risk.
          Any resemblance to copyrighted, trademarked, or third-party characters is purely coincidental.
          <Link to="/legal" className="text-white/70 hover:text-[#FF3333] ml-1 underline">Full disclaimer</Link>.
        </p>
      </div>

      <div className="border-t border-white/5 py-6 text-center font-mono text-[10px] text-white/30 tracking-widest">
        © {new Date().getFullYear()} FORGED ATHLETICS · ALL RIGHTS RESERVED
      </div>
    </footer>
  );
}
